import {ReportAssetLocationHistoryModel} from "../../models/reports/ReportAssetLocationHistoryModel";

export class ReportAssetLocationHistoryCtrl {
    public static $inject = ['$scope','ReportAssetLocationHistoryModel'];
    constructor(public $scope:any, public model:ReportAssetLocationHistoryModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.name, this.model.location, this.model.assetType, this.model.department, this.model.disposalStatus, this.model.checkedinStatus, this.model.missing, this.model.tagType], (newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
